import {
    ButtonPrimary,
    Row,
    RowList,
    ButtonFixedFooterLayout,
    Text6,
    Text3,
    ButtonLink,
    skinVars,
    useDialog,
    IconInformationUserRegular,
    IconLockClosedRegular,
    Circle,
    Text1,
    useWindowSize,
} from '@telefonica/mistica';
import React, { useEffect } from 'react';
import { isBrowser } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { isWebviewAndroid, isWebviewIOS } from '../../../../utils/navigation/controlDevices';
import './index.scss';
import { TrackingEvents } from '../../../../utils/dataTransformation/tracking';
import { getOnboardingWebview, getOnboardingWebview2 } from '../../../../services/EscalationService';
import { AxiosResponse } from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { getCustomerData } from '../../../../services/CustomerService';

const OnboardingFirstVerification: React.FC = () => {
    const { state } = useLocation();
    const navigate = useNavigate();
    const { trackingScreenView } = new TrackingEvents();
    const { t } = useTranslation();
    const { dialog } = useDialog();
    const size = useWindowSize();
    const params = new URLSearchParams(window.location.search);
    const obd = params.get('functionality');

    useEffect(() => {
        const state = uuidv4();
        const v2fiscalType = process.env.REACT_APP_WEBVIEW_OBD_V2_FISCAL_TYPES?.split(',').find(
            (item: string) => item === 'NIE',
        )!;
        getCustomerData().then((response) => {
            if (response?.data?.fiscalIdType?.startsWith(v2fiscalType)) {
                getOnboardingWebview2(window.location.origin + '/obd/callback/v2', state).then(
                    (response: AxiosResponse) => {
                        const { data } = response;
                        const { onBoardingId, contactSessionId } = data;
                        sessionStorage.setItem(
                            'escalation',
                            JSON.stringify({ onBoardingId, contactSessionId, state: { data: data, obd: obd } }),
                        );
                        navigate(`/obd/daon/v2?functionality=${params.get('functionality')}`, {
                            state: { data: data, obd: obd },
                        });
                    },
                );
            } else {
                getOnboardingWebview(window.location.origin + '/obd/callback', state).then(
                    (response: AxiosResponse) => {
                        const { data } = response;
                        const { onBoardingId, contactSessionId } = data;
                        sessionStorage.setItem(
                            'escalation',
                            JSON.stringify({ onBoardingId, contactSessionId, state: { data: data, obd: obd } }),
                        );
                        navigate(`/obd/daon?functionality=${params.get('functionality')}`, {
                            state: { data: data, obd: obd },
                        });
                    },
                );
            }
        });
    }, []);

    useEffect(() => {
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView();
        }
    }, []);

    return (
        <div
            className='onboarding-first-verification-page'
            style={{
                borderLeft: size.width >= 1024 ? `24px solid ${skinVars.colors.backgroundSkeleton}` : 'none',
                borderRight: size.width >= 1024 ? `24px solid ${skinVars.colors.backgroundSkeleton}` : 'none',
            }}
        >
            {isBrowser && (
                <div
                    className='onboarding-first-verification-header-navigationBar'
                    style={{ background: skinVars.colors.navigationBarBackground }}
                ></div>
            )}
            <div className='onboarding-first-verification'>
                <ButtonFixedFooterLayout
                    button={
                        <ButtonPrimary
                            onPress={() =>
                                dialog({
                                    icon: <IconInformationUserRegular color={skinVars.colors.brand} size={64} />,
                                    title: t('verification_important_information'),
                                    message: t('verification_important_information_explain_text1'),
                                    acceptText: t('got_it'),
                                    link: (
                                        <ButtonLink
                                            onPress={() => {
                                                window.open('https://o2online.es/privacidad/', '_blank');
                                            }}
                                        >
                                            {t('visitO2webText')}
                                        </ButtonLink>
                                    ),
                                    onAccept: () => {
                                        window.location.href = state.data.url;
                                    },
                                })
                            }
                        >
                            {t('onboardingFirstVerButton')}
                        </ButtonPrimary>
                    }
                >
                    <div className='onboarding-first-verification__wrapper'>
                        <div className='onboarding-first-verification__wrapper__icon'>
                            <IconLockClosedRegular size={64} color={skinVars.colors.brand}></IconLockClosedRegular>
                        </div>
                        <div className='onboarding-first-verification__wrapper__text1'>
                            <Text6 color={skinVars.colors.textPrimary}>{t('verification_secure')}</Text6>
                        </div>
                        <div className='onboarding-first-verification__wrapper__text2'>
                            <Text3 regular color={skinVars.colors.textSecondary}>
                                {t('verification_secure_explain')}
                            </Text3>
                        </div>
                        <div className='onboarding-first-verification__wrapper__rows'>
                            <RowList>
                                <Row
                                    asset={
                                        <Circle size={24} backgroundColor={skinVars.colors.controlActivated}>
                                            <Text1 medium color={skinVars.colors.textPrimaryInverse}>
                                                1
                                            </Text1>
                                        </Circle>
                                    }
                                    title={t('identity_check')}
                                    description={t('identity_check_explain')}
                                />
                                <Row
                                    asset={
                                        <Circle size={24} backgroundColor={skinVars.colors.controlActivated}>
                                            <Text1 medium color={skinVars.colors.textPrimaryInverse}>
                                                2
                                            </Text1>
                                        </Circle>
                                    }
                                    title={t('contact_media_verification')}
                                    description={t('contact_media_verification_explain')}
                                />
                            </RowList>
                        </div>
                    </div>
                </ButtonFixedFooterLayout>
            </div>
        </div>
    );
};

export default OnboardingFirstVerification;
